
<template>
    <div class="fixed inset-0 p-6 bg-gray-1000 bg-opacity-90 z-30 overscroll-y-contain overflow-y-auto text-blue-500">
        <div class="flex flex-col w-full h-full items-center justify-center">
            <div class="bg-white dark:bg-gray-900 dark:text-gray-400 border dark:border-gray-700 rounded p-5 flex flex-col space-y-4 w-full md:w-2/3 lg:w-1/2 2xl:w-1/2 max-h-[38rem] overflow-y-auto">
                
                    <div class="flex items-start justify-between">
                        <button 
                            title="Chiudi"
                            @click.prevent="$emit('closeModal')"
                            class="ml-auto bg-transparent min-w-min flex items-center justify-center transform hover:rotate-90 duration-300">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64" class="w-4 fill-current text-gray-800 dark:text-gray-400">
                                    <path d="M34.5,32L62.2,4.2c0.7-0.7,0.7-1.8,0-2.5c-0.7-0.7-1.8-0.7-2.5,0L32,29.5L4.2,1.8c-0.7-0.7-1.8-0.7-2.5,0
                                        c-0.7,0.7-0.7,1.8,0,2.5L29.5,32L1.8,59.8c-0.7,0.7-0.7,1.8,0,2.5c0.3,0.3,0.8,0.5,1.2,0.5s0.9-0.2,1.2-0.5L32,34.5l27.7,27.8
                                        c0.3,0.3,0.8,0.5,1.2,0.5c0.4,0,0.9-0.2,1.2-0.5c0.7-0.7,0.7-1.8,0-2.5L34.5,32z"/>
                                </svg>
                        </button>
                    </div>
                <template v-if="!maintainance">
                    <h1 class="text-xl flex items-center space-x-1 dark:text-white">
                        <span class="">{{ $t('newInventoryModal.title', $store.state.locale) }}</span>
                    </h1>
                    <p>
                        {{ $t('newInventoryModal.msg', $store.state.locale) }}
                    </p>
                    <!-- Date Selection -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
                        <!-- Month -->
                        <div class="mb-1 sm:mb-2">
                            <label for="from" class="inline-block mb-1 uppercase">{{ $t('selectDateModal.month', $store.state.locale) }}</label>
                            <div class="w-full relative">
                                <select v-model="selected_month" @change.prevent="setSelectedDate" class="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-blue-500 focus:shadow-outline dark:bg-gray-800 dark:border-gray-700 dark:hover:border-blue-400 dark:focus:border-blue-400">
                                    <option value="0" selected disabled>{{ $t('selectDateModal.month_select', $store.state.locale) }}</option>
                                    <option
                                        v-for="(m, i) in months"  :key="i"
                                        :value="i+1"  
                                    >
                                        {{ $t(`months.${m}`, $store.state.locale) }}
                                    </option>
                                </select>
                                <span class="absolute right-4 top-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 fill-current"><path d="M17,9.17a1,1,0,0,0-1.41,0L12,12.71,8.46,9.17a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l4.24,4.24a1,1,0,0,0,1.42,0L17,10.59A1,1,0,0,0,17,9.17Z"/></svg>
                                </span>
                            </div>
                            <span
                                v-if="$store.state.errors.errors.from" 
                                class="font-bold text-sm text-red-500" >
                                {{ $store.state.errors.errors.from[0] }}
                            </span>
                        </div>
                        <!-- Year -->
                        <div class="mb-1 sm:mb-2">
                            <label for="from" class="inline-block mb-1 uppercase">{{ $t('selectDateModal.year', $store.state.locale) }}</label>
                            <div class="w-full relative">
                                <select v-model="selected_year"  @change.prevent="setSelectedDate" class="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-blue-500 focus:shadow-outline dark:bg-gray-800 dark:border-gray-700 dark:hover:border-blue-400 dark:focus:border-blue-400">
                                    <option value="0" selected disabled>{{ $t('selectDateModal.year_select', $store.state.locale) }}</option>
                                    <option
                                        v-for="(y, i) in years"  :key="i"
                                        :value="y"  
                                    >
                                        {{ y }}
                                    </option>
                                </select>
                                <span class="absolute right-4 top-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 fill-current"><path d="M17,9.17a1,1,0,0,0-1.41,0L12,12.71,8.46,9.17a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l4.24,4.24a1,1,0,0,0,1.42,0L17,10.59A1,1,0,0,0,17,9.17Z"/></svg>
                                </span>
                            </div>
                            <span
                                v-if="$store.state.errors.errors.from" 
                                class="font-bold text-sm text-red-500" >
                                {{ $store.state.errors.errors.from[0] }}
                            </span>
                        </div>
                    </div>
                    <!-- Products -->
                    <div v-if="!limitError">
                        <!-- Type -->
                        <div  class="w-full flex items-center justify-between space-x-5">
                            <span class="text-xl">{{ $t('newInventoryModal.typology', $store.state.locale) }}:</span>
                            <label class="relative flex justify-between space-x-2 items-center group">
                                <span :class="reportType === 1 ? 'text-blue-500' : 'text-gray-400'">
                                    Usage
                                </span>
                                <div class="w-14 h-6 flex items-center flex-shrink-0 p-1 rounded-full duration-300 ease-in-out relative"
                                :class="reportType === 1 ? 'bg-blue-500' : 'bg-gray-300'">
                                    <button 
                                        class="absolute top-1 bottom-1 w-4 rounded-full bg-white duration-300"
                                        :class="reportType === 2 ? 'right-1' : 'left-1'"
                                        @click.prevent="toggleReportType"
                                    ></button>
                                </div>
                                <span :class="reportType === 2 ? 'text-blue-500': 'text-gray-400'">
                                    Delivery
                                </span>
                            </label>
                        </div>
                        <!-- Products -->
                        <div class="grid grid-cols-1 w-full h-56 lg:overflow-y-auto scrollbar-hidden">
                            <div class="flex items-start justify-start w-full overflow-x-auto scrollbar-hidden">
                                <table class="w-full"> 
                                    <thead class="border-b-2 dark:border-gray-700">
                                        <tr>
                                            <td class="p-2 text-sm">
                                                <button 
                                                    @click.prevent="toggleProducts"
                                                    class="w-5 h-5 rounded border text-white flex items-center justify-center"
                                                    :class="products.length && selected_products.length === products.length ? 'bg-light-green-500 border-light-green-500' : 'bg-gray-100 dark:bg-gray-700 dark:border-gray-500'">
                                                    <svg v-show="products.length && selected_products.length === products.length" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 fill-current"><path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"/></svg>    
                                                </button>
                                            </td>
                                            <td class="p-2 text-sm">
                                                {{ $t('productTable.cols.name', $store.state.locale) }}
                                            </td>
                                            <td class="p-2 text-sm">
                                                {{ $t('productTable.cols.formulator', $store.state.locale) }}
                                            </td>
                                            <td class="p-2 text-sm">
                                                {{ $t('productTable.cols.quantity', $store.state.locale) }} (Kg)
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody v-if="pageStatus === 'loading'">
                                        <tr>
                                            <td colspan="4" class="w-full p-3">
                                                <!-- La percentuale la porta la barra, che e' una
                                                     `progressbar` con il suo valore: chi ascolta la
                                                     interroga quando vuole invece di sentirsi rileggere
                                                     la frase intera a ogni lotto. Per questo il testo
                                                     visibile qui sotto non e' piu' una live region —
                                                     con entrambe, la stessa cifra veniva annunciata due
                                                     volte. Il cambio di step lo annuncia la regione in
                                                     fondo, che di suo cambia una volta sola.

                                                     Niente `aria-busy` sul contenitore: un lettore di
                                                     schermo puo' **rinviare** gli annunci di una live
                                                     region dentro un elemento occupato, e rilasciarli
                                                     quando torna `false`. Qui non tornerebbe mai —
                                                     a fine caricamento il contenitore viene rimosso,
                                                     non liberato — e l'annuncio del cambio di fase
                                                     andrebbe perso. Dove serve davvero si lega a uno
                                                     stato che si spegne, come `:aria-busy="resolving"`
                                                     in `TableRow.vue`. -->
                                                <div class="flex flex-col items-center justify-center space-y-2">
                                                    <p class="text-sm">
                                                        {{ refreshPhase === REFRESH_PHASE.CATALOGUE
                                                            ? $t('newInventoryModal.checking_catalogue', $store.state.locale, { percent: refreshPercent })
                                                            : $t('newInventoryModal.checking_recheck', $store.state.locale) }}
                                                    </p>
                                                    <!-- Fase 1: le pagine di catalogo si contano, quindi la
                                                         percentuale e' vera. -->
                                                    <div
                                                        v-if="refreshPhase === REFRESH_PHASE.CATALOGUE"
                                                        class="w-2/3 h-2 bg-gray-200 dark:bg-gray-700 rounded overflow-hidden"
                                                        role="progressbar"
                                                        :aria-valuenow="refreshPercent"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        :aria-label="$t('newInventoryModal.checking_catalogue_label', $store.state.locale)">
                                                        <div
                                                            class="h-full bg-blue-500 transition-all duration-300"
                                                            :style="{ width: refreshPercent + '%' }"></div>
                                                    </div>
                                                    <!-- Fase 2: l'unita' e' il prodotto non risolto e non se
                                                         ne conosce il costo, quindi un loader senza numeri:
                                                         una percentuale qui mescolerebbe due misure diverse. -->
                                                    <svg v-else class="animate-spin w-8 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                                    <!-- Il cambio di step, annunciato una volta sola e
                                                         senza spostare il focus: la regione e' nel DOM
                                                         da subito e resta vuota nella fase 1, quindi
                                                         cio' che si annuncia e' il testo che compare al
                                                         passaggio. Tenerla separata dal testo visibile
                                                         e' cio' che evita di rileggere la percentuale a
                                                         ogni lotto. -->
                                                    <p class="sr-only" aria-live="polite" aria-atomic="true">
                                                        {{ refreshPhase === REFRESH_PHASE.RECHECK
                                                            ? $t('newInventoryModal.checking_recheck', $store.state.locale)
                                                            : '' }}
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="pageStatus === 'error'">
                                        <tr>
                                            <td colspan="4" class=" w-full">
                                                <div class="text-center flex flex-col items-center justify-center space-y-2 w-full p-3">
                                                    <h3 class="text-xl">
                                                        {{ $t('newInventoryModal.error_status', $store.state.locale) }}
                                                    </h3>
                                                    <button 
                                                        @click.prevent="init"
                                                        class="bg-white dark:bg-gray-800 rounded border dark:border-gray-700 px-4 py-2 hover:border-blue-500 dark:hover:border-blue-400 hover:text-blue-500 dark:hover:text-blue-400 duration-300 flex items-center justify-center space-x-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64" xml:space="preserve" class="w-4 fill-current"><g><path d="M8.4,29c0.3,0,0.7-0.1,1-0.2l11.1-3.9c1.2-0.4,1.8-1.7,1.4-2.9c-0.4-1.2-1.7-1.8-2.9-1.4l-6.9,2.4 c3.3-8.6,11.7-14.4,21.3-14.4c10.5,0,19.6,7,22.2,17c0.3,1.2,1.5,1.9,2.7,1.6c1.2-0.3,1.9-1.5,1.6-2.7c-3.1-12-14-20.4-26.6-20.4 c-11.2,0-21.1,6.6-25.2,16.5l-2.1-6c-0.4-1.2-1.7-1.8-2.9-1.4c-1.2,0.4-1.8,1.7-1.4,2.9l3.8,10.9C6.1,28.3,7.2,29,8.4,29z"/><path d="M62.1,49.7L58,39c-0.3-0.7-0.8-1.3-1.5-1.6c-0.7-0.3-1.5-0.3-2.2,0l-11,4.2c-1.2,0.4-1.7,1.7-1.3,2.9 c0.4,1.2,1.7,1.7,2.9,1.3l6.9-2.6C47.8,50.5,40,55.3,31.3,55.3c-9.9,0-18.6-6.2-21.7-15.4c-0.4-1.2-1.7-1.8-2.8-1.4 c-1.2,0.4-1.8,1.7-1.4,2.8c3.7,11,14.1,18.4,25.9,18.4c10.3,0,19.6-5.7,24.3-14.5l2.3,6.1c0.3,0.9,1.2,1.4,2.1,1.4 c0.3,0,0.5,0,0.8-0.2C62,52.2,62.5,50.9,62.1,49.7z"/></g></svg>
                                                        <span class="text-sm">{{ $t('newInventoryModal.try_again', $store.state.locale) }}</span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else-if="pageStatus === 'void' && !products.length">
                                        <tr>
                                            <td colspan="7" class="text-center  w-full p-3"> 
                                                <h3 class="text-xl">
                                                    {{ $t('newInventoryModal.void_status', $store.state.locale) }}
                                                </h3>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else-if="pageStatus === 'fetched' && !products.length">
                                        <tr>
                                            <td colspan="7" class="text-center  w-full p-3"> 
                                                <h3 class="text-2xl">
                                                    {{ $t('productTable.no_product', $store.state.locale) }}
                                                </h3>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else-if="products.length">
                                        <tr 
                                            v-for="product in products" :key="product.id"
                                            class="border-b dark:border-gray-700">
                                            <td class="p-2 text-sm">
                                                <button 
                                                    @click.prevent="toggleSingleProduct(product)"
                                                    class="w-5 h-5 rounded border text-white flex items-center justify-center"
                                                    :class="selected_products.length && selected_products.some(p => p.id === product.id) ? 'bg-light-green-500 border-light-green-500' : 'bg-gray-100 dark:bg-gray-700 dark:border-gray-500'">
                                                    <svg v-show="selected_products.length && selected_products.some(p => p.id === product.id)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 fill-current"><path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"/></svg>    
                                                </button>
                                            </td>
                                            <td class="p-2 text-xs">
                                                {{ product.name }}
                                            </td>
                                            <td class="p-2 text-xs">
                                                <span>
                                                    {{ setFormulatorName(product) }}
                                                </span>
                                            </td>
                                            <td class="p-2 text-xs">
                                                {{ product.incheck_reference ? product.incheck_reference.quantity / 100 : '-' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <template v-if="pageStatus !== 'loading'" >
                            <div class="flex flex-col w-full space-y-2">
                                <div  v-if="noMatchStatus" class="flex flex-col space-y-1 w-full py-2 px-4 text-center">
                                    <p 
                                       
                                        class="text-sm text-red-500"
                                        v-html="$t('newInventoryModal.noMatchesDetected', $store.state.locale)">
                                    </p>
                                    <RouterLink
                                        :to="`/${$store.state.locale}/dashboard`" 
                                        class="text-sm text-red-500"
                                        v-html="$t('newInventoryModal.productsSection', $store.state.locale)">
                                    </RouterLink>
                                </div>
                                <!-- Attenzione: vi sono prodotti non associati. <br> 
                                    Torna alla sezione <RouterLink :to="`/${$store.state.locale}/dashboard`" >"Prodotti"</RouterLink> per completare il matching. -->
                                <div
                                    v-if="products.length && selected_products.length" 
                                    class="flex items-center justify-end space-x-3 py-2">
                                    <button 
                                        
                                        @click.prevent="openReportPreview"
                                        class="px-5 py-3 font-medium leading-5 text-center text-white rounded lg:mt-0 duration-300 lg:w-auto text-blue-500 hover:underline">
                                        Preview
                                    </button>
                                    <button 
                                        @click.prevent="newReport"
                                        class="px-5 py-3 font-medium leading-5 text-center text-white rounded lg:mt-0 duration-300 lg:w-auto"
                                        :class="setSubmitClasses"
                                        v-html="setSubmitContent"
                                        :disabled="newInventoryStatus !== 'void'">
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- Limit Error -->
                    <div v-else class="h-56 flex flex-col space-y-2 items-center justify-center text-center">
                        <span class="text-xl font-semibold">
                            {{ $t('newInventoryModal.limitErrorTitle', $store.state.locale).replace('__reportRange', reportRange) }}
                        </span>
                        <span class="text-lg">
                            {{ $t('newInventoryModal.limitErrorBody', $store.state.locale) }}
                        </span>
                    </div>
                </template>
                <template v-else>
                    <div class="w-full h-full flex items-center justify-center p-10 text-center">
                        <span class="text-xl text-red-500">
                            {{ $t('newInventoryModal.maintainance', $store.state.locale) }}
                        </span>
                    </div>
                </template>
            </div>
        </div>
        <teleport to="body">
            <ReportPreview 
                v-if="products.length && showReportPreview"
                :referenceMonth="selected_month"
                :referenceYear="selected_year"
                :products="products.length"
                :selectedDate="selected_date"
                @closeModal="closeReportPreview"
            />
            <DuplicateReportLinesModal
                v-if="duplicateGroups.length"
                :groups="duplicateGroups"
                @closeModal="duplicateGroups = []"
            />
            <NegativeQuantityModal
                v-if="negativeProducts.length"
                :products="negativeProducts"
                @closeModal="negativeProducts = []"
            />
            <RejectedReportLinesModal
                v-if="rejectedLines.length"
                :lines="rejectedLines"
                :total="rejectedTotal"
                @closeModal="rejectedLines = []"
            />
        </teleport>
    </div>
</template>

<script>
import { ref, 
         computed,
         defineAsyncComponent }     from 'vue';
import moment           from 'moment';
import { useStore }     from 'vuex';
import { useI18n }      from 'vue-i18n';
import { useRouter }      from 'vue-router';
import SnackbarComposables  from '../../composables/SnackbarComposables';
import ZdhcService from '../../services/Zdhc/ZdhcService';
import ProductService from '../../services/ProductService';
import requestManager from '../../composables/useRequestManager';
import { isTransportError } from '../../composables/useApi';
import { associatedReferenceId } from '../../utils/matchStatus';
import { runPeriodRefresh, REFRESH_PHASE, REFRESH_STATUS } from '../../utils/periodRefresh';
import { periodIsFrozen } from '../../utils/inventoryPeriod';
import { duplicateGroupsFrom } from '../../utils/duplicateReportGroups';
import { rejectedLinesFrom } from '../../utils/rejectedReportLines';
import { negativeQuantityProducts, weightOf } from '../../utils/negativeQuantityProducts';

export default
{
    emits:['closeModal', 'newReport'],
    props:{ parentInventories: {required:true}},
    components:
    {
        ReportPreview: defineAsyncComponent( () => import('../report/ReportPreview.vue')),
        DuplicateReportLinesModal: defineAsyncComponent( () => import('./DuplicateReportLinesModal.vue')),
        NegativeQuantityModal: defineAsyncComponent( () => import('./NegativeQuantityModal.vue')),
        RejectedReportLinesModal: defineAsyncComponent( () => import('./RejectedReportLinesModal.vue'))
    },
    setup(props, {emit})
    {
        /**
         *
         * Data
         *
         */
        // Aligned with the Gateway 90-day creation window; the backend
        // (ReportingPeriod) stays the authority and re-validates (E22).
        const reportRange = 90;
        const maintainance = false;
        const router = useRouter();
        const store = useStore();
        const showReportPreview = ref(false);
        const noMatchStatus = ref(false);
        const pageStatus = ref('void');
        const reportType = ref(1);
        const newInventoryStatus = ref('void');
        /*
         * I gruppi di prodotti che il report non puo' contenere insieme,
         * quando l'api li rifiuta. Vuoto = nessun rifiuto da mostrare.
         */
        const duplicateGroups = ref([]);
        /*
         * I prodotti selezionati con quantita' negativa, che il report non puo'
         * riportare. Vuoto = niente da segnalare. A differenza dei duplicati
         * non arriva da un rifiuto dell'api: lo decide la guardia prima di
         * partire, perche' le quantita' le abbiamo gia' qui.
         */
        const negativeProducts = ref([]);
        /*
         * Le righe che il Gateway ZDHC non ha accettato, gia' tradotte nei
         * prodotti locali. Vuoto = nessun rifiuto da mostrare.
         *
         * `rejectedTotal` e' quante righe erano state inviate in tutto: senza
         * il totale il numero dei rifiutati non dice se il report e' quasi a
         * posto o tutto da rifare. Si registra qui e non si ricalcola dopo da
         * `selected_products`, che nel frattempo l'utente puo' cambiare.
         */
        const rejectedLines = ref([]);
        const rejectedTotal = ref(0);
        const products = ref([]);
        // L'avanzamento della verifica di periodo, come lo racconta il backend:
        // `percent` e' la fase 1 (pagine di catalogo), `null` la fase 2, dove
        // l'unita' e' un'altra e una percentuale direbbe il falso.
        const refreshPhase = ref(REFRESH_PHASE.CATALOGUE);
        const refreshPercent = ref(0);
        const {t} = useI18n();
        const { addSnackbar } = SnackbarComposables();
        const { storeInventory, refreshPeriod } = ZdhcService();
        const { indexProduct } = ProductService();
        const selected_products = ref([]);
        let selected_month= ref(moment().format('M'));
        let selected_year= ref(moment().format('YYYY'));
        let dateLimit= ref(moment().subtract(reportRange, 'days').format('YYYY-MM-DD'));
        let limitError= ref(false);
        let months = ref([
            'jan',
            'feb',
            'mar',
            'apr',
            'may',
            'jun',
            'jul',
            'aug',
            'sep',
            'oct',
            'nov',
            'dec',
        ]);
        let years = ref(Array.from({length: moment().format('YYYY') - 1900}, (value, index) => 1901 + index));
        const selected_date = ref(moment().format('YYYY-MM-DD'));

        /**
         *
         *  Computed
         *
         */
        const setSubmitContent = computed( () => 
        {
            switch(newInventoryStatus.value)
            {
                case 'void':
                    return t('newInventoryModal.create_report', store.state.locale);
                case 'loading':
                    return `<svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>`;
                case 'success':
                    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 fill-current text-white"><path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"/></svg>';
                case 'error':
                    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 fill-current text-white"><path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"/></svg>`;
                default:
                    return t('newInventoryModal.create_report', store.state.locale);
            }
        });
        const setSubmitClasses = computed( () =>
        {
            switch(newInventoryStatus.value)
            {
                case 'void': case 'loading': default:
                    return 'bg-blue-500 hover:bg-blue-300';
                case 'error':
                    return `bg-red-500 hover:bg-red-700`;
                case 'success':
                    return `bg-green-500 hover:bg-green-700`;
            }
        });
        const isDateInRange = computed( () =>
        {
            return  moment(selected_date.value).isBetween(dateLimit.value, moment(), undefined, '[]');
        });

        /**
         *
         * Methods
         *
         */
        const init = async () => 
        {
            if(!isDateInRange.value) 
            {
                limitError.value = true;
            }
            else 
            {
                requestManager.abortAll();
                refreshPhase.value = REFRESH_PHASE.CATALOGUE;
                refreshPercent.value = 0;
                noMatchStatus.value = false;
                limitError.value = false;
                pageStatus.value = 'loading';
                products.value = [];
                // Il dialog e' teleportato, quindi sopravvive al cambio di
                // periodo: senza questo resterebbe aperto a nominare prodotti
                // di un mese che non e' piu' quello a schermo.
                negativeProducts.value = [];
                rejectedLines.value = [];
                checkProducts();
            }
        };
        const getProducts = async () => 
        {
            const res = await indexProduct( 
                    moment(selected_date.value).startOf('month').format('YYYY-MM-DD'),
                    'desc', 
                    null, 
                    null,
                    100,
                    15,
                    false
            );
            if(res)
            {
                if('results' in res)
                {
                    products.value = res.results;
                    products.value.forEach( p => p.incheck_reference = p.incheck_references[0]);
                    selected_products.value = products.value.filter(e => e.incheck_reference.suggestion_id || e.incheck_reference.zdhc_product_id || e.incheck_reference.no_match || e.incheck_reference.no_match_id );
                    if(products.value.some(product => !product.incheck_reference.suggestion_id && !product.incheck_reference.zdhc_product_id && !product.incheck_reference.no_match && !product.incheck_reference.no_match_id)) noMatchStatus.value = true
                    pageStatus.value = 'fetched';
                }
            }
            else pageStatus.value = 'error';
        }
        /**
         * La verifica del periodo, a lotti, prima di mostrare i prodotti.
         *
         * L'elenco non si manda: il periodo sta nell'URL e i prodotti li
         * risolve il backend dall'utente loggato. Per questo qui non c'e' piu'
         * la lettura di cento prodotti che serviva solo a dare in pasto al
         * vecchio ciclo la lista da scorrere — quella la fa `getProducts()`
         * dopo, quando c'e' davvero qualcosa da mostrare.
         *
         * Anche lo scioglimento delle associazioni morte se n'e' andato con il
         * ciclo: un prodotto uscito dal catalogo lo timbra la lettura a lotti
         * (`catalogue_missing_at`) e a fine passata il backend scioglie la sua
         * associazione, con la stessa guardia sul periodo gia' dichiarato che
         * applicava il browser. Era l'ultima scrittura automatica rimasta qui.
         */
        const checkProducts = async () =>
        {
            const period = moment(selected_date.value).format('YYYY-MM');

            const res = await runPeriodRefresh(period, {
                requestBatch: (p, cursor) => refreshPeriod(p, cursor),
                // Timeout e connessione caduta non portano una risposta: senza
                // questo risalirebbero come eccezione e la modale resterebbe su
                // "caricamento" per sempre, senza il pulsante di riprova.
                isTransportFailure: isTransportError,
                onProgress: (progress) =>
                {
                    refreshPhase.value = progress.phase;
                    if(progress.percent !== null) refreshPercent.value = progress.percent;
                },
            });

            // L'annullamento non e' un guasto: la modale si sta chiudendo o il
            // periodo e' cambiato, e chi arriva dopo comanda. Lasciare lo stato
            // com'e' evita di scrivere un errore sopra una schermata nuova.
            if(res.status === REFRESH_STATUS.ABORTED) return;

            if(res.status !== REFRESH_STATUS.SUCCESS)
            {
                pageStatus.value = 'error';
                return;
            }

            getProducts();
        }
        const setSelectedDate = () => 
        {
            selected_date.value = moment(`${selected_year.value}-${selected_month.value}-1`, 'YYYY-MM-D').format('YYYY-MM-DD');
            if(!moment(selected_date.value).isSame(moment(), 'month'))
            {
                selected_date.value = moment(selected_date.value).endOf('month').format('YYYY-MM-DD');
            }
            init();
        };
        const toggleSingleProduct = (product) => 
        {
            let id = product.id;
            if(selected_products.value.some(p => p.id === id))
            {
                return selected_products.value = selected_products.value.filter(p => p.id != id);
            }
            else 
            {   
                if(product.incheck_reference.suggestion_id || product.incheck_reference.zdhc_product_id || product.incheck_reference.no_match || product.incheck_reference.no_match_id) return selected_products.value.push(product);
                else return addSnackbar('warning','This product doesn\'t have a match or suggestion');
            }
        };
        /**
         * Stesso mese e stesso anno, come faceva la condizione inline. Sta qui
         * e non nel modulo perche' moment e' una dipendenza del componente: il
         * predicato del periodo resta puro e testabile senza montare nulla.
         */
        const isSameMonth = (a, b) => moment(a).isSame(moment(b), 'month') && moment(a).isSame(moment(b), 'year');

        const toggleProducts = () => 
        {
            if( products.value.some( e => !e.incheck_reference.suggestion_id && !e.incheck_reference.zdhc_product_id && !e.incheck_reference.no_match && !e.incheck_reference.no_match_id)) return addSnackbar('warning', 'Impossible to select all products, some of them have no match or suggestion')
            return selected_products.value.length === products.value.length 
                    ? selected_products.value = [] 
                    : selected_products.value = products.value;
        };
        /**
         * New asynchronous flow (Gateway 2.0): the backend creates the
         * draft inventory, syncs the lines and submits it for supplier
         * review — no more synchronous pdf. The outcome is a submitted
         * inventory, the report arrives later through the status poller.
         */
        const newReport = async () =>
        {
            if( products.value.some( e => !e.incheck_reference.suggestion_id && !e.incheck_reference.zdhc_product_id && !e.incheck_reference.no_match && !e.incheck_reference.no_match_id)) return addSnackbar('warning', 'Impossible to generate a report, make sure each producta has been associated');
            if(!selected_products.value.length) return addSnackbar('warning','Select at least one product');
            // A local draft for the period is retryable (the backend reuses
            // it and diff-syncs the lines) and so is a declined one — after a
            // refusal the fix is to correct the associations and send a new
            // inventory. Only submitted, published and legacy pdf records
            // block. The predicate lives in utils/inventoryPeriod.
            else if(periodIsFrozen(props.parentInventories, selected_date.value, isSameMonth)) return addSnackbar('warning','An inventory for this period already exists');
            else if(!isDateInRange.value) return addSnackbar('warning','You cannot generate reports for this date');
            /*
             * Ogni tentativo riparte da zero. Tutti i dialog del report si
             * aprono su una lista non vuota, quindi azzerarle qui — prima di
             * qualunque ramo che ne riempia una — e' cio' che garantisce che
             * non possano restare aperti insieme.
             */
            duplicateGroups.value = [];
            negativeProducts.value = [];
            rejectedLines.value = [];
            /*
             * Una quantita' negativa la rifiuta l'api sul `weight`, ma come
             * `validation_error`: l'interceptor lo assorbe e a schermo resta
             * «ricarica la pagina», alla fine di un periodo di lavoro. E il
             * rifiuto e' sull'intero payload, per indice di riga, quindi
             * nemmeno potrebbe nominare il prodotto da correggere. Qui le
             * quantita' ci sono gia': si dice prima, e si dice quale.
             *
             * Un dialog e non uno snackbar, come per i duplicati: il messaggio
             * nomina prodotti e su quelli si deve agire.
             */
            const negatives = negativeQuantityProducts(selected_products.value);
            if(negatives.length)
            {
                negativeProducts.value = negatives;
                return;
            }
            newInventoryStatus.value = 'loading';
            let incheckProducts = [];
            /*
             * Da quale prodotto locale viene ogni riga dell'invio. L'api rifiuta
             * i duplicati per **indice di riga** — non conosce i nostri
             * prodotti — e questa e' la corrispondenza per tradurre quegli
             * indici in nomi. Riempita qui dentro e non ricavata dopo
             * dall'ordine di `selected_products`: la corrispondenza si dichiara
             * dove nasce, o diventa un'assunzione che il prossimo che tocca
             * questo ciclo non sa di dover mantenere.
             */
            let lineProducts = [];
            selected_products.value.forEach( p =>
            {
                let reference = p.incheck_reference;
                let formulator_name = p.formulator ? p.formulator.name : (p.formulator_name ?? '-');
                // Dal modulo e non a mano: e' la stessa aritmetica con cui la
                // guardia qui sopra decide se una riga e' negativa, e le due
                // non devono poter divergere — o il numero mostrato all'utente
                // non sarebbe piu' quello che blocca il report.
                let weight = weightOf(reference);
                // Dall'helper e non a mano: qui l'id non finisce in una
                // schermata, entra nel payload dell'inventario. Un blank passato
                // per buono fa viaggiare un prodotto con un'identita' che il
                // Gateway rifiuta, invece di mandarlo inline per nome.
                let referenceId = associatedReferenceId(reference);

                if(referenceId)
                {
                    incheckProducts.push({
                        product_reference_id: referenceId,
                        formulator_name: formulator_name,
                        weight: weight
                    });
                }
                else
                {
                    // No catalogue reference (no-match, or legacy match not
                    // yet re-matched): the product travels inline by name.
                    incheckProducts.push({
                        product_name: p.name,
                        formulator_name: formulator_name,
                        weight: weight
                    });
                }

                // Un prodotto = una riga, su entrambi i rami: l'indice
                // dell'una e' l'indice dell'altra.
                lineProducts.push(p);
            });
            if(incheckProducts.length)
            {
                const res = await storeInventory({
                    period: moment(selected_date.value).format('YYYY-MM'),
                    type: reportType.value === 1 ? 'usage' : 'delivery', //  1: Usage || 2: Delivery
                    products: incheckProducts,
                    // Local product ids: the backend attaches them to the
                    // inventory_product pivot so counters, report detail and
                    // already-used-product checks keep working.
                    local_product_ids: selected_products.value.map( p => p.id),
                    submit: true
                });
                if(res && !res.error)
                {
                    /*
                     * Il Gateway ha rifiutato una o piu' righe. Un dialog e non
                     * uno snackbar, come per i duplicati: il messaggio nomina
                     * prodotti, dice perche' sono stati rifiutati e su quelli si
                     * deve agire.
                     *
                     * I nomi li mette il client, come sopra: l'api manda gli
                     * indici di riga, e chi sa da quale prodotto viene ogni riga
                     * e' chi l'ha costruita.
                     */
                    if(res.lines_failed && res.lines_failed.length)
                    {
                        newInventoryStatus.value = 'error';
                        setTimeout( () => newInventoryStatus.value = 'void', 3000);
                        rejectedTotal.value = incheckProducts.length;
                        rejectedLines.value = rejectedLinesFrom(res.lines_failed, lineProducts);

                        // Se il payload arrivasse senza righe non si apre un
                        // dialog vuoto: meglio il messaggio generico che una
                        // finestra che non dice niente.
                        if(rejectedLines.value.length) return;

                        return addSnackbar('error', `${t('newInventoryModal.lines_failed', store.state.locale)} (${res.lines_failed.length})`);
                    }
                    if(res.submitted)
                    {
                        addSnackbar('success', t('newInventoryModal.report_submitted', store.state.locale));
                    }
                    else if(res.submit_error === 'submit_disabled')
                    {
                        // Degraded flow (submit endpoint off): the draft is
                        // on the Gateway, the supplier completes it there.
                        addSnackbar('warning', t('newInventoryModal.submit_disabled', store.state.locale));
                    }
                    else
                    {
                        addSnackbar('warning', t('newInventoryModal.submit_rejected', store.state.locale));
                    }
                    newInventoryStatus.value = 'success';
                    return emit('newReport');
                }
                newInventoryStatus.value = 'error';
                setTimeout( () => newInventoryStatus.value = 'void', 3000);
                /*
                 * Due o piu' prodotti selezionati portano la stessa identita'
                 * ZDHC. Un dialog e non uno snackbar: il messaggio nomina
                 * prodotti, puo' portare piu' gruppi, e su questo si deve
                 * agire — due secondi in basso a sinistra non bastano.
                 *
                 * I nomi li mette il client: l'api manda gli indici di riga,
                 * e chi sa da quale prodotto viene ogni riga e' chi l'ha
                 * costruita.
                 */
                if(res && res.error === 'zdhc_duplicate_product_lines')
                {
                    duplicateGroups.value = duplicateGroupsFrom(res.duplicates, lineProducts);

                    // Se il payload arrivasse senza gruppi non si apre un
                    // dialog vuoto: meglio il messaggio generico che una
                    // finestra che non dice niente.
                    if(duplicateGroups.value.length) return;
                }
                if(res && res.error === 'zdhc_conflict') return addSnackbar('error', t('newInventoryModal.conflict', store.state.locale));
                if(res && res.error === 'zdhc_supplier_not_linked') return addSnackbar('error', t('newInventoryModal.not_linked', store.state.locale));
                if(res && res.message) return addSnackbar('error', res.message);
                return addSnackbar('error', t('snackbar.refresh', store.state.locale));
            }
        };
        const toggleReportType = () => 
        {
            return reportType.value === 1 ? reportType.value = 2 : reportType.value = 1;
        };
        const openReportPreview = () => 
        {
            showReportPreview.value = true;
            document.body.classList.add('overflow-hidden');
        };
        const closeReportPreview = () => 
        {
            showReportPreview.value = false;
            document.body.classList.remove('overflow-hidden');
        };
        const setFormulatorName = (product) => 
        {
            if(product.formulator)
            {
                return product.formulator.name.length > 20
                                ? product.formulator.name.substring(0, 17)+'...'
                                : product.formulator.name;
            }
            return product.formulator_name ?? '-';
        };

        /**
         *
         * Hooks
         *
         */
        init();

        return {
            /* Data */
            reportRange,
            maintainance,
            showReportPreview,
            selected_date,
            pageStatus,
            newInventoryStatus,
            duplicateGroups,
            negativeProducts,
            rejectedLines,
            rejectedTotal,
            selected_month,
            selected_year,
            selected_products,
            months,
            years,
            products,
            reportType,
            limitError,
            noMatchStatus,
            router,
            /* Computed */
            setSubmitContent,
            setSubmitClasses,
            refreshPhase,
            refreshPercent,
            REFRESH_PHASE,
            /* Methods */
            init,
            setSelectedDate,
            toggleSingleProduct,
            toggleProducts,
            newReport,
            toggleReportType,
            openReportPreview,
            closeReportPreview,
            setFormulatorName
        }
    }
}
</script>
<style scoped>
/* Chi ha chiesto meno movimento non deve subire una rotazione continua per
   sapere che si sta aspettando: restano la percentuale, l'etichetta della
   progressbar e il testo di stato. Sta qui e non nella configurazione di
   Tailwind perche' la
   variante `motion-reduce` non e' abilitata in questo progetto, e accenderla
   globalmente ricostruirebbe tutto il CSS per una riga — stesso motivo del
   blocco gemello in `TableRow.vue`.

   Il `:deep()` serve al loader del pulsante di invio, che arriva da `v-html`:
   quel markup non porta l'attributo di scope, quindi la sola regola scoped lo
   lascerebbe girare. */
@media (prefers-reduced-motion: reduce)
{
    .animate-spin,
    :deep(.animate-spin)
    {
        animation: none;
    }
}
</style>
